import { Input } from "../../../components/Input/Input";
import { rewardCellError } from "./invites";
import { RewardField } from "./RewardField";
import grid from "./HelpTypesEditor.module.css";
// The ladder's four tracks: the two tables stand one above the other, and the
// names and rewards of both are read down the same two columns.
import styles from "./InviterRewardsEditor.module.css";

interface Props {
  name: string;
  reward: unknown;
  nameModified: boolean;
  rewardModified: boolean;
  onNameChange: (next: string) => void;
  /** `undefined` for an emptied box — the invitee is then paid nothing. */
  onRewardChange: (next: unknown) => void;
}

/**
 * `invites.invitee_reward_name` and `invites.invitee_reward` — what the invited
 * player gets, as a table of one row under the columns the inviter's ladder
 * uses below it. One row, because it is one reward whatever step the inviter
 * is on (mockup .codelane/artifacts/t-164/config-invites-ladder.html
 * L450-L468).
 */
export function InviteeRewardEditor({
  name,
  reward,
  nameModified,
  rewardModified,
  onNameChange,
  onRewardChange,
}: Props) {
  return (
    <div className={grid.gridEditor}>
      <div className={grid.scroller}>
        <div className={`${grid.row} ${styles.steps} ${grid.head}`}>
          <div>for</div>
          <div>name</div>
          <div>reward</div>
          <div />
        </div>
        <div className={`${grid.row} ${styles.steps} ${styles.lastRow}`}>
          <div className={styles.forAll}>every invited player</div>
          <div className={grid.cell}>
            <Input
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              modified={nameModified}
              aria-label="Invitee reward name"
            />
          </div>
          <div className={grid.cell}>
            <RewardField
              value={reward}
              onChange={onRewardChange}
              error={rewardCellError(reward)}
              modified={rewardModified}
              aria-label="Invitee reward"
            />
          </div>
          <div />
        </div>
      </div>
    </div>
  );
}
